const cellId = (row: number, column: number): string => `${row}:${column}`

export default cellId
